import React from "react";
import Link from "gatsby-link";
import Linkedin from "react-icons/lib/fa/linkedin-square";
import Github from "react-icons/lib/fa/github-square";
import Youtube from "react-icons/lib/fa/youtube-square";
import Scopus from "../assets/images/scopus.svg";

const MainFooter = (props) => {
               return(
            <div className="c-main-footer">
              <p className="c-main-footer__note">
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://github.com/robgen"><Github className="ai ai-3x" /></a>
                  <a target="_blank" style={{ color: 'gray', borderBottom: '0px' }} href="https://www.linkedin.com/in/roberto-gentile-507a7411b/"><Linkedin className="ai ai-3x" /></a>
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://www.youtube.com/channel/UC3Vy2h6wI_3HTcDC5ILGFvg"><Youtube className="ai ai-3x" /></a>
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://www.researchgate.net/profile/Roberto_Gentile"><i className="ai ai-3x ai-researchgate-square" style={{ verticalAlign: 'middle', padding: '2px'  }}></i></a>
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://orcid.org/0000-0002-7682-4490"><i className="ai ai-3x ai-orcid-square" style={{ verticalAlign: 'middle', padding: '2px'  }}></i></a>
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://scholar.google.hr/citations?user=vSoKv_kAAAAJ&hl=en"><i className="ai ai-3x ai-google-scholar-square" style={{ verticalAlign: 'middle', padding: '2px' }}></i></a>
                  <a style={{ color: 'gray', borderBottom: '0px' }} href="https://www.scopus.com/authid/detail.uri?authorId=56868328600"><img style={{ width: '100px', height: '100px', padding: '2px', verticalAlign: 'middle' }} src={Scopus} /></a>
              </p>
            </div>
               );
}
export default MainFooter;



// WEBPACK FOOTER //
// ./src/components/MainFooter.jsx